import React, { useState } from "react";
import styled from "styled-components";
import SubscriptionAdminsContent from "../../../components/AdminCentral/Admins/SubscriptionAdminsContent";

const breakpoints = {
  tablet: 768,
  phone:  480,
};
const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
  // @media (max-width: ${breakpoints.phone}px) {
  //   width: 300px;
  // }
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground}; 
  @media (max-width: ${breakpoints.phone}px) {
    width: 350px;
  }
`;

const Title = styled.text`
 font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px; 

  span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
    @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const SubscriptionAdminsPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = useState("Administrators");

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
    <Title colors={colors}> Admins </Title>
    <Container colors={colors}>
    <SubscriptionAdminsContent colors={colors} />
    </Container>
    </DashboardContainer>
  );
};

export default SubscriptionAdminsPage;
